// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1_nn7","rootCenter":"LoadMoreObserver_rootCenter__1Yu1i","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1PFLD"};